;(function(){
  // --- 1. INJECT NEW CSS (AIRBNB STYLE) ---
  var style = document.createElement('style');
  style.innerHTML = `
    .purchase-toast-wrapper {
      position: fixed; bottom: 20px; left: 20px; z-index: 21474;
      font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
      pointer-events: none; /* Let clicks pass through empty space */
      display: flex; flex-direction: column; align-items: flex-start;
    }

    .purchase-toast-card {
      pointer-events: auto;
      background: #ffffff;
      color: #222222;
      /* EXPANDED STATE (Default Dimensions) */
      width: 320px;
      max-width: calc(100vw - 40px);
      padding: 12px;
      border-radius: 12px;
      box-shadow: 0 8px 20px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.04);
      
      display: flex;
      align-items: center;
      gap: 12px;
      
      /* ANIMATIONS */
      transform: translateY(20px);
      opacity: 0;
      transition: 
        transform 0.4s cubic-bezier(0.2, 0.8, 0.2, 1), 
        opacity 0.4s ease,
        width 0.4s cubic-bezier(0.2, 0.8, 0.2, 1),
        padding 0.4s ease,
        gap 0.3s ease,
        border-radius 0.3s ease;

      cursor: pointer;
      user-select: none;
      touch-action: pan-y; /* Allow vertical scroll/swipe */
      overflow: hidden;
      position: relative;
    }

    /* --- MINIMIZED STATE (Compact Pill) --- */
    .purchase-toast-card.minimized {
      width: auto;
      height: auto;
      padding: 4px 10px 4px 4px;
      gap: 8px;
      justify-content: flex-start;
      border-radius: 20px;
    }

    /* VISIBILITY STATES */
    .purchase-toast-card.is-visible { transform: translateY(0); opacity: 1; }
    .purchase-toast-card.swiped-up { transform: translateY(-40px) scale(0.95); opacity: 0; pointer-events: none; }

    /* IMAGE */
    .purchase-toast__img {
      width: 56px; height: 56px;
      border-radius: 8px;
      object-fit: cover;
      flex-shrink: 0;
      background-color: #f7f7f7;
      transition: transform 0.3s ease, width 0.3s ease, height 0.3s ease, border-radius 0.3s ease;
    }
    .purchase-toast-card:hover .purchase-toast__img { transform: scale(1.02); }
    .purchase-toast-card.minimized .purchase-toast__img { 
      width: 24px; 
      height: 24px; 
      border-radius: 50%;
    }

    /* BADGE (Only shows when minimized) */
    .purchase-toast__badge {
      position: relative;
      background: transparent;
      color: #222;
      font-size: 12px;
      font-weight: 500;
      padding: 0;
      white-space: nowrap;
      opacity: 0;
      transition: opacity 0.3s ease;
      pointer-events: none;
      display: none;
      line-height: 1;
    }
    .purchase-toast-card.minimized .purchase-toast__badge { 
      opacity: 1;
      display: flex;
      align-items: center;
    }

    /* TEXT CONTENT (Hidden when minimized) */
    .purchase-toast__content {
      flex: 1;
      min-width: 0; /* Critical for ellipsis */
      display: flex;
      flex-direction: column;
      justify-content: center;
      opacity: 1;
      transition: opacity 0.2s 0.1s; /* Slight delay on show */
    }
    .purchase-toast-card.minimized .purchase-toast__content { 
      opacity: 0; 
      pointer-events: none; 
      position: absolute; 
    }

    .purchase-toast__line-1 { font-size: 11px; color: #717171; line-height: 1.3; }
    .purchase-toast__line-2 {
      font-size: 13px; color: #222; font-weight: 600; line-height: 1.4;
      /* Trailing Ellipsis Logic */
      white-space: nowrap; overflow: hidden; text-overflow: ellipsis; 
      padding-right: 4px;
    }
    .purchase-toast__line-3 { font-size: 11px; color: #999; margin-top: 1px; }

    /* CLOSE BUTTON (Hidden when minimized) */
    .purchase-toast__close-btn {
      width: 24px; height: 24px;
      display: flex; align-items: center; justify-content: center;
      background: transparent; border: none; cursor: pointer; padding: 0;
      color: #ddd; transition: color 0.2s ease;
      flex-shrink: 0;
      opacity: 1;
    }
    .purchase-toast-card.minimized .purchase-toast__close-btn { opacity: 0; pointer-events: none; position: absolute; }
    .purchase-toast__close-btn:hover { color: #222; }
    .purchase-toast__close-btn svg { width: 14px; height: 14px; stroke-width: 2; }
    
    /* Mobile Override */
    @media (max-width: 480px) {
      .purchase-toast-wrapper { bottom: 10px; left: 10px; right: 10px; align-items: flex-start; }
      .purchase-toast-card { width: 100%; max-width: 100%; }
      .purchase-toast-card.minimized { width: auto; max-width: none; }
    }
  `;
  document.head.appendChild(style);

  // --- 2. LOGIC ---
  try {
    var key = Object.getOwnPropertyNames(window).find(function(k){ return k && String(k).indexOf('untamed_protection_') === 0; });
    if (key && window[key] && window[key].disabled) return;
  } catch (_) {}

  function parseBool(val){ return String(val).toLowerCase() === 'true'; }

  function initRecentPurchaseToast(){
    var container = document.getElementById('purchase-toast-container');
    
    // Create wrapper if not exists to hold CSS class
    if (container && !container.classList.contains('purchase-toast-wrapper')) {
        container.classList.add('purchase-toast-wrapper');
        container.style.display = 'flex'; // Override the display:none from liquid
    }
    if (!container) return;

    var data = container.dataset || {};
    var maxToasts = parseInt(data.maxToasts || '3', 10);
    var toastDuration = parseInt(data.toastDuration || '5', 10);
    var toastInterval = parseInt(data.toastInterval || '20', 10);
    var useRandomProducts = parseBool(data.useRandomProducts || 'true');
    var maxRandomProducts = parseInt(data.maxRandomProducts || '10', 10);
    var currentProductId = data.currentProductId || '';

    // Original data fetching logic
    var defaultNames = []; var defaultCities = [];
    try { defaultNames = JSON.parse(data.defaultNames || '[]'); } catch(_) {}
    try { defaultCities = JSON.parse(data.defaultCities || '[]'); } catch(_) {}

    var state = {
      toasts: [],
      activeToasts: 0,
      products: [],
      suppressedByUser: sessionStorage.getItem('purchase_toast_suppressed') === 'true',
      cycleInterval: null
    };

    if (state.suppressedByUser) return;

    function getProductImage(product) {
        var imageSrc = null;
        if (product.images && product.images.length > 0) imageSrc = product.images[0];
        else if (product.featured_image) imageSrc = (typeof product.featured_image === 'string') ? product.featured_image : product.featured_image.src;
        else if (product.image) imageSrc = (typeof product.image === 'string') ? product.image : product.image.src;
        else if (product.media && product.media.length > 0 && product.media[0].src) imageSrc = product.media[0].src;
        if (imageSrc && imageSrc.indexOf('//') === 0) imageSrc = 'https:' + imageSrc;
        return imageSrc || 'data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2050%2050%22%3E%3Crect%20width%3D%2250%22%20height%3D%2250%22%20fill%3D%22%23eee%22%2F%3E%3C%2Fsvg%3E';
    }

    function preloadImages(products){
      if (!products || !products.length) return;
      products.forEach(function(product){
        var src = getProductImage(product);
        if(src) { var img = new Image(); img.src = src; }
      });
    }

    function fallbackProducts(){
      var placeholder = 'data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2050%2050%22%3E%3Crect%20width%3D%2250%22%20height%3D%2250%22%20fill%3D%22%23eee%22%2F%3E%3Cpath%20d%3D%22M25%2015L35%2035H15z%22%20fill%3D%22%23aaa%22%2F%3E%3C%2Fsvg%3E';
      return [
        { title: 'Classic T-Shirt', images: [placeholder], url: '#' },
        { title: 'Designer Hoodie', images: [placeholder], url: '#' },
        { title: 'Premium Sneakers', images: [placeholder], url: '#' }
      ];
    }

    function getRandom(arr){ return arr[Math.floor(Math.random()*arr.length)]; }

    function getRandomProduct(){
      if (!state.products.length) return { title: 'Sample Product', images: [null], url: '#' };
      return getRandom(state.products);
    }

    // --- HTML GENERATION & INTERACTION ---
    function createToastElement(){
      var product = getRandomProduct();
      var name = defaultNames.length ? getRandom(defaultNames) : 'Customer';
      var city = defaultCities.length ? getRandom(defaultCities) : 'Somewhere';
      var times = ['Just now','2m ago','5m ago','12m ago','1h ago'];
      var time = getRandom(times);
      var imageSrc = getProductImage(product);

      var toast = document.createElement('div');
      // Default state: Minimized (Square)
      toast.className = 'purchase-toast-card minimized'; 
      
      toast.innerHTML = 
        '<img class="purchase-toast__img" src="' + imageSrc + '" alt="' + (product.title || 'Product') + '">' +
        '<div class="purchase-toast__badge">' + name + ' from ' + city + '</div>' +
        '<div class="purchase-toast__content">' +
          '<div class="purchase-toast__line-1">' + name + ' in ' + city + '</div>' +
          '<div class="purchase-toast__line-2">Purchased ' + (product.title || 'Product') + '</div>' +
          '<div class="purchase-toast__line-3">' + time + '</div>' +
        '</div>' +
        '<button class="purchase-toast__close-btn" aria-label="Close">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
        '</button>';

      // --- EVENTS ---

      // 1. CLICK TO EXPAND
      toast.addEventListener('click', function(e) {
        if (toast.classList.contains('minimized')) {
           toast.classList.remove('minimized');
           
           // If expanded, give the user more time to read it (duration + 3 seconds)
           if (toast.dismissTimer) clearTimeout(toast.dismissTimer);
           var newDismissTime = (toastDuration * 1000) + 3000;
           toast.dismissTimer = setTimeout(function(){ hideToast(toast); }, newDismissTime);
        }
      });

      // 2. CLOSE BUTTON (Stop Prop so it doesn't trigger expand)
      var closeBtn = toast.querySelector('.purchase-toast__close-btn');
      closeBtn.addEventListener('click', function(e){
        e.stopPropagation(); 
        suppressAndHide(toast);
      });

      // 3. SWIPE UP TO REMOVE
      var touchStartY = 0;
      toast.addEventListener('touchstart', function(e){
        touchStartY = e.touches[0].clientY;
      }, {passive: true});

      toast.addEventListener('touchmove', function(e){
        var touchCurrentY = e.touches[0].clientY;
        var diff = touchStartY - touchCurrentY;
        // If swiped UP more than 30px
        if (diff > 30) {
            toast.classList.add('swiped-up');
            suppressAndHide(toast);
        }
      }, {passive: true});

      return toast;
    }

    function suppressAndHide(toast) {
        state.suppressedByUser = true;
        sessionStorage.setItem('purchase_toast_suppressed', 'true');
        stopToastCycle();
        setTimeout(function(){ hideToast(toast); }, 400); 
    }

    function showToast(){
      if (state.activeToasts >= maxToasts || state.suppressedByUser) return;
      var toast = createToastElement();
      container.appendChild(toast);
      state.toasts.push(toast);
      state.activeToasts++;
      
      toast.offsetHeight; // Force reflow
      setTimeout(function(){ toast.classList.add('is-visible'); }, 50);
      
      var dismissTime = toastDuration * 1000;
      toast.dismissTimer = setTimeout(function(){ hideToast(toast); }, dismissTime);
    }

    function hideToast(toast){
      if (toast.dismissTimer) clearTimeout(toast.dismissTimer);
      toast.classList.remove('is-visible');
      setTimeout(function(){
        if (toast.parentNode) toast.parentNode.removeChild(toast);
        var idx = state.toasts.indexOf(toast); if (idx > -1) state.toasts.splice(idx,1);
        state.activeToasts--;
      }, 400);
    }

    function startToastCycle(){
      if (state.suppressedByUser) return;
      state.cycleInterval = setInterval(function(){ showToast(); }, toastInterval * 1000);
    }
    function stopToastCycle(){ if (state.cycleInterval) clearInterval(state.cycleInterval); }

    // --- DATA LOADING ---
    (async function loadProducts(){
      try {
        if (useRandomProducts) {
          if (Array.isArray(window.storeProducts) && window.storeProducts.length) {
            state.products = window.storeProducts;
          }
          if (!state.products.length && currentProductId) {
            try {
              var res = await fetch('/recommendations/products.json?product_id=' + encodeURIComponent(currentProductId) + '&limit=' + maxRandomProducts);
              var data = await res.json();
              if (data && data.products && data.products.length) state.products = data.products;
            } catch(_) {}
          }
          if (!state.products.length && window.productData) {
            state.products = [window.productData];
          }
          if (!state.products.length) {
            try {
              var res2 = await fetch('/collections/all/products.json?limit=' + maxRandomProducts);
              var data2 = await res2.json();
              if (data2 && data2.products && data2.products.length) state.products = data2.products;
            } catch(_) {}
          }
          if (!state.products.length) state.products = fallbackProducts();
        } else {
          if (window.productData) state.products = [window.productData];
          else if (Array.isArray(window.storeProducts) && window.storeProducts.length) state.products = window.storeProducts;
          else state.products = fallbackProducts().slice(0,1);
        }
      } catch(_) {
        state.products = fallbackProducts();
      }
      preloadImages(state.products);
      startToastCycle();
      setTimeout(function(){ showToast(); }, 3000);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecentPurchaseToast);
  } else {
    initRecentPurchaseToast();
  }

  document.addEventListener('shopify:section:load', function(){ initRecentPurchaseToast(); });
})();